import { RefObject, useCallback, useEffect } from 'react';

export const useClickOutside = (refs: RefObject<HTMLDivElement | null>[], callback: () => void) => {
  // Memoized handleClickOutside using useCallback
  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      const isOutside = refs.every(
        (ref) => !ref.current || (ref.current && !ref.current.contains(event.target as Node)),
      );
      if (isOutside) {
        callback();
      }
    },
    [refs, callback],
  );

  useEffect(() => {
    document.addEventListener('mouseup', handleClickOutside);

    return () => {
      document.removeEventListener('mouseup', handleClickOutside);
    };
  }, [handleClickOutside]);
};
